// O perfil público aberto por cima da tela atual (tocar no rosto ou no nome de alguém). Abre numa folha, sem trocar de
// tela: na sala e na mesa, sair da tela tiraria a pessoa da mesa.
import { useSyncExternalStore } from 'react';

let aberto: string | null = null;
const ouvintes = new Set<() => void>();
const avisar = () => { for (const f of ouvintes) f(); };

export function abrirPerfil(usuario: string): void { aberto = usuario; avisar(); }
export function fecharPerfil(): void { aberto = null; avisar(); }
export function usePerfilAberto(): string | null {
  return useSyncExternalStore((f) => { ouvintes.add(f); return () => ouvintes.delete(f); }, () => aberto, () => null);
}
